const processError = require('./error-process');
const mergeOptions = require('merge-options');
const deepEqual = require('deep-equal');

export const createAsset = (space, data) => {
  if (data.overwriteKeys) {
    delete data.overwriteKeys;
  }

  return space.createAsset(data).catch(
    processError
  );
};

export function updateAsset(asset, data) {
  if (deepEqual(asset, data)) {
    return Promise.resolve(asset);
  }

  // Assign all field values to the asset:
  asset.fields = mergeOptions(asset.fields, data.fields);
  asset.metadata = mergeOptions(asset.metadata, data.metadata);

  // Update fields that should not be merged but overwritten
  if (data.overwriteKeys) {
    data.overwriteKeys.forEach((overwriteKey) => {
      asset.fields[overwriteKey] = data.fields[overwriteKey];
    });
  }

  // Update asset:
  return asset.update().catch(
    processError
  );
}

export const publishAsset = (asset) => {
  const needsPublish = !asset.sys.publishedVersion || asset.sys.version > asset.sys.publishedVersion + 1;

  if (!needsPublish) {
    return Promise.resolve(asset);
  }

  return asset.publish().catch(
    processError
  );
};

export const unpublishAsset = (asset) => {
  const needsUnpublish = asset.sys.publishedVersion;

  if (!needsUnpublish) {
    return Promise.resolve(asset);
  }

  return asset.unpublish().catch(
    processError
  );
};

export const archiveAsset = (asset) => {
  const needsArchiving = !asset.isArchived();

  if (!needsArchiving) {
    return Promise.resolve(asset);
  }

  return unpublishAsset(asset).then(() => {
    return asset.archive().catch(
      processError
    );
  });
};

export const unarchiveAsset = (asset) => {
  const needsUnarchiving = asset.sys.archivedAt;

  if (!needsUnarchiving) {
    return Promise.resolve(asset);
  }

  return asset.unarchive().catch(
    processError
  );
};
